<template>
  <div class="hero-full-container background-image-container white-text-container space-bg">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <div class="hero-full-wrapper">
            <div class="text-content">
              <h1>Hello,<br>
                <span id="typed-strings">
                  <span>感谢访问 诺朗科技</span>
                  <span>We Are Rollong</span>
                  <span>Roll: vi.翻滚</span>
                  <span>Long: adv.长久；始终</span>
                </span>
                <span id="typed"></span>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer-container footer-ctm text-center">
      <div class="container">
        <div class="row">
          <div class="col-xs-12" style="padding-top: 1rem">
            <p style="color: #333;">Copyright © 2013-2020 诺朗科技
              <a href="https://beian.miit.gov.cn" id="beian" target="_blank" style="color:blue;">蜀ICP备13019233号-3</a>
              <!-- <a href="https://beian.miit.gov.cn" id="beian" target="_blank" style="color:blue;">蜀ICP备13019233号-2</a> -->
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  components: {},
  props: {},
  computed: {},
  data() {
    return {
      noWarn: true,
    }
  },
  watch: {},
  methods: {},
  mounted() {
    type();
    movingBackgroundImage();
  },
}
</script>
<style lang="scss">
.hero-full-container {
  &.space-bg {
    background-image: url('../assets/images/space.jpg');
  }
}
</style>